export default __webpack_public_path__ + "static/media/painting_frame.098ce02c.svg";